import { Input } from '@/shared/components/ui/input';
import { Search } from 'lucide-react';

interface CareerSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export default function CareerSearchBar({
  value,
  onChange,
  placeholder = 'Search by role, department, or location...',
}: CareerSearchBarProps) {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />

      <Input
        type="search"
        autoComplete="off"
        value={value}
        placeholder={placeholder}
        className="h-12 bg-white pl-10"
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
